import * as React from "react";

import { Modal } from "src/library/components/Modal";
import { ITerminology } from "src/library/utils/string-manipulations/tokenize-string";

import { IOrder } from "../../api/orders.api";

interface IProps {
  show: boolean;
  terminology: ITerminology;
  onConfirm: () => void;
  handleDismiss: () => void;
  order: IOrder;
}

const ConvertToAdhocOrderModal: React.ReactFCWithChildren<IProps> = ({
  show, onConfirm, handleDismiss, terminology, order
}) => {
  // dynamic message based on the type of conversion
  const message = React.useMemo(() => {
    if (order.type === "scheduled") {
      return `This ${terminology.order.singular.text} was scheduled by a ${terminology.schedule.singular.text} setup from a ${
        terminology.list.singular.text
      }. If you make changes to this ${terminology.order.singular.text}, then any future updates you make to the ${
        terminology.list.singular.text
      } or ${terminology.schedule.singular.text} won’t be reflected here.`;
    }

    if (order.type === "bulk") {
      return `This ${terminology.order.singular.text} receives automatic updates. By making changes you will unsubscribe it from any future automatic updates.`;
    }

    return "";
  }, [
    order.type,
    terminology.list.singular.text,
    terminology.order.singular.text,
    terminology.schedule.singular.text
  ]);

  return (
    <Modal
      small
      type="confirm"
      show={show}
      title={`Convert to an ${terminology.adhoc.singular.text} ${terminology.order.singular.text}?`}
      body={message}
      actions={[
        {
          name: "No, go back",
          action: () => handleDismiss(),
          $buttonType: "secondary"
        },
        {
          name: `Yes, submit my ${terminology.order.singular.text}`,
          action: () => {
            onConfirm();
            handleDismiss();
          },
          $buttonType: "primary"
        }
      ]}
      backgroundAction={() => handleDismiss()}
    />
  );
};

export default ConvertToAdhocOrderModal;
